import api from "dao/providers/axios";
import appconfig from "config/appconfig";
import environment from "lib/environment";

const roleBaseUrl= { baseURL: environment.get().api.portalURL };
const roleManagementEndpoint = appconfig.endpoints.oAuthRoles;
const socialBaseUrl = { baseURL: environment.get().api.socialGraphServiceURL };
const socialServiceEndpoint = appconfig.endpoints.socialService;

export const daoRoleListGet = () => api.get(roleManagementEndpoint,roleBaseUrl);

export const daoRolePost = (payload) => api.post(roleManagementEndpoint, payload,roleBaseUrl);

export const daoGetRoleById = (roleId) => api.get(`${roleManagementEndpoint}/${roleId}`, roleBaseUrl);

export const daoRolePatch = (roleId, payload) => api.patch(`${roleManagementEndpoint}/${roleId}`, payload, roleBaseUrl);

export const daoRoleApproversGet = (roleId) => api.get(`${roleManagementEndpoint}/${roleId}/approvers`,roleBaseUrl);

export const daoRoleApproversPut = (roleId,approver,payload) => api.put(`${roleManagementEndpoint}/${roleId}/approvers/${approver}`,payload, roleBaseUrl);

export const daoRoleApproversDelete = (roleId,approver) => api.delete(`${roleManagementEndpoint}/${roleId}/approvers/${approver}`, roleBaseUrl);

export const daoSocialServiceGet = (text) => api.get(socialServiceEndpoint(text), socialBaseUrl);